'use es6';

import SeamlessImmutable from 'seamless-immutable';
import userInfo from 'hub-http/userInfo';
import { init } from 'ContentUtils/Routes';
import { DESIGN_MANAGER_ACCESS } from 'DesignData/constants/Scopes';
import { arrayToKeyMirror } from 'DesignData/lib/array';

class Auth {
  constructor() {
    this.__data = SeamlessImmutable({
      user: null,
      gates: null,
      portal: null
    });
    this.__initialized = false;
  }

  init() {
    if (this.__initialized) {
      throw new Error('Auth Utils: Cannot be initialized twice.');
    }

    this.__initialized = true;
    return userInfo().then(({
      user,
      gates,
      portal
    }) => {
      init(gates);
      this.__data = SeamlessImmutable({
        user,
        portal,
        gates: arrayToKeyMirror(gates)
      });
      return this.__data;
    });
  }
  /**
   * 403 check
   */


  isAllowed() {
    const {
      user = {}
    } = this.__data;
    const {
      scopes = []
    } = user;
    return scopes.includes(DESIGN_MANAGER_ACCESS);
  }

  get() {
    return this.__data;
  }

}

export default new Auth();